import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {colors} from '../../../styleVariables';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  text-align: left;
  line-height: 1rem;
  font-size: 0.8rem !important;

  > strong {
    color: ${(props) => props.theme};
  }

  span {
    color: ${colors.gray} !important;
  }
`;

const Location = ({currentPosition, theme, timezone}) => {
  return (
    <Style className="mt-3" theme={theme}>
      <strong className="mb-1" style={{color: theme}}>
        Última atualização
      </strong>
      <span className="text-gray">
        {currentPosition && currentPosition.fixTime ?
          moment(currentPosition.fixTime).format('YYYY-MM-DD HH:mm:ss') :
          ''}
      </span>
      <strong className="mt-3 mb-1">Endereço</strong>
      <span>{currentPosition.address}</span>
    </Style>
  );
};

export default Location;
